export default __webpack_public_path__ + "static/media/HASSAN_NL_EPILOG2.ebc30e2e.mp3";